import { useCallback, useState } from 'react';
import { ApiService, CompaniesByFirm } from 'api';
import { ERROR_404 } from 'common/config/api';
import { useResponse } from 'services/hooks/useResponse';

export const useGetCompaniesFromPreviousMD = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [companies, setCompanies] = useState<CompaniesByFirm[]>([]);
  const { processErrorResponse } = useResponse();
  const defaultErrorMessage = 'An error occurred while loading Companies';

  const getCompanies = useCallback(
    async (firmId: number) => {
      if (firmId) {
        try {
          setIsLoading(true);

          const response = await ApiService.apiFirmsCompaniesListList(firmId.toString());
          if (response) {
            setCompanies(response);
          }
        } catch (error) {
          processErrorResponse({
            error,
            defaultErrorMessage,
            config: {
              [ERROR_404]: {
                notification: false,
                callback: () => setCompanies([]),
              },
            },
            action: 'get companies',
          });
        } finally {
          setIsLoading(false);
        }
      }
    },
    [processErrorResponse]
  );

  return { isLoading, companies, getCompanies };
};
